// extracted by mini-css-extract-plugin
module.exports = {"placemark":"a10a3f92e9--placemark--15hd4","append":"a10a3f92e9--append--1yUMe"};